/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type ChatMessageAttachmentType =
  /** 日程調整 */
  | 'BOOKING_REQUEST';

export type SendChatMessageAttachmentInput = {
  /** JSON 文字列 */
  rawContent: string;
  type: ChatMessageAttachmentType;
};

export type SendNormalChatMessageInput = {
  attachments: Array<SendChatMessageAttachmentInput>;
  chatRoomId: string | number;
  message: string;
  sendAsStaff?: boolean | null | undefined;
};

export type SendQuestionChatMessageInput = {
  answerSelections: Array<string>;
  chatRoomId: string | number;
  message: string;
  sendAsStaff?: boolean | null | undefined;
};

export type SendNormalChatMessageMutationVariables = Exact<{
  input: Types.SendNormalChatMessageInput;
}>;


export type SendNormalChatMessageMutation = { sendNormalChatMessage: { isSucceeded: boolean } };

export type SendQuestionChatMessageMutationVariables = Exact<{
  input: Types.SendQuestionChatMessageInput;
}>;


export type SendQuestionChatMessageMutation = { sendQuestionChatMessage: { isSucceeded: boolean } };

export type RequestReviewMutationVariables = Exact<{
  roomId: string | number;
}>;


export type RequestReviewMutation = { requestReview: any };


export const SendNormalChatMessageDocument = gql`
    mutation sendNormalChatMessage($input: SendNormalChatMessageInput!) {
  sendNormalChatMessage(input: $input) {
    isSucceeded
  }
}
    `;

/**
 * __useSendNormalChatMessageMutation__
 *
 * To run a mutation, you first call `useSendNormalChatMessageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendNormalChatMessageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendNormalChatMessageMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSendNormalChatMessageMutation(options: VueApolloComposable.UseMutationOptions<SendNormalChatMessageMutation, SendNormalChatMessageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendNormalChatMessageMutation, SendNormalChatMessageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SendNormalChatMessageMutation, SendNormalChatMessageMutationVariables>(SendNormalChatMessageDocument, options);
}
export type SendNormalChatMessageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendNormalChatMessageMutation, SendNormalChatMessageMutationVariables>;
export const SendQuestionChatMessageDocument = gql`
    mutation sendQuestionChatMessage($input: SendQuestionChatMessageInput!) {
  sendQuestionChatMessage(input: $input) {
    isSucceeded
  }
}
    `;

/**
 * __useSendQuestionChatMessageMutation__
 *
 * To run a mutation, you first call `useSendQuestionChatMessageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendQuestionChatMessageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendQuestionChatMessageMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSendQuestionChatMessageMutation(options: VueApolloComposable.UseMutationOptions<SendQuestionChatMessageMutation, SendQuestionChatMessageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendQuestionChatMessageMutation, SendQuestionChatMessageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SendQuestionChatMessageMutation, SendQuestionChatMessageMutationVariables>(SendQuestionChatMessageDocument, options);
}
export type SendQuestionChatMessageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendQuestionChatMessageMutation, SendQuestionChatMessageMutationVariables>;
export const RequestReviewDocument = gql`
    mutation requestReview($roomId: ID!) {
  requestReview(roomId: $roomId)
}
    `;

/**
 * __useRequestReviewMutation__
 *
 * To run a mutation, you first call `useRequestReviewMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRequestReviewMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRequestReviewMutation({
 *   variables: {
 *     roomId: // value for 'roomId'
 *   },
 * });
 */
export function useRequestReviewMutation(options: VueApolloComposable.UseMutationOptions<RequestReviewMutation, RequestReviewMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RequestReviewMutation, RequestReviewMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RequestReviewMutation, RequestReviewMutationVariables>(RequestReviewDocument, options);
}
export type RequestReviewMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RequestReviewMutation, RequestReviewMutationVariables>;